<div *ngIf="report">
  <div class="stick-top">
    <mat-toolbar>
      <mat-icon>monetization_on</mat-icon> Invoices
    </mat-toolbar>
  </div>

  <div class="padded vbox-space">
    <table class="basicTable vtable">
      <thead>
      <tr>
        <th colspan="100">Company Information</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <th>Name</th>
        <td *ngIf="!auth.hasRole('ACCOUNT_TRANSACT')">
          {{report.companyName}}
        </td>
        <td *ngIf="auth.hasRole('ACCOUNT_TRANSACT')">
          <micro-company-select [(companyId)]="companyId" (companyIdChange)="load()" [required]="true"></micro-company-select>
        </td>
      </tr>
      <tr>
        <th>Balance Limit</th>
        <td *ngIf="!report.unlimitedBalance">
          {{report.balanceLimit | currency: undefined: undefined: '1.4-4'}}
        </td>
        <td class="CRITICAL" *ngIf="report.unlimitedBalance">
          UNLIMITED
        </td>
      </tr>
      <tr>
        <th>Balance</th>
        <td>
          {{report.balance | currency: undefined: undefined: '1.4-4'}}
        </td>
      </tr>
      <tr *ngIf="auth.hasRole('ACCOUNT_ADMIN') && auth.hasRole('COMPANY_ADMIN')">
        <th>Flush Balance Cache</th>
        <td>
          <button mat-raised-button type="button" (click)="flushCache()">Flush</button>
        </td>
      </tr>
      </tbody>
    </table>
    <micro-accountReportMonth [showLink]="authService.hasRole('ACCOUNT_TRANSACT')" [companyId]="companyId" [year]="thisYear" [month]="thisMonth"></micro-accountReportMonth>
  </div>
</div>

<mat-toolbar><mat-icon>history</mat-icon> History</mat-toolbar>
<div class="vbox-space padded">
  <div>
    <micro-year-month-select [(year)]="historyYear" [(month)]="historyMonth" [required]="true"></micro-year-month-select>
  </div>
  <div>
    <micro-accountReportMonth [showLink]="true" [companyId]="companyId" [year]="historyYear" [month]="historyMonth"></micro-accountReportMonth>
  </div>
</div>
